/*
* Created on Jan 20, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import MainNavigationComponent from "../MainNavigationComponent";
import {Route, Routes, useLocation, Navigate, useSearchParams} from "react-router-dom";
import MainContentSummary from "./MainContentSummary";
import SiteIndexComponent from "../sites/SiteIndexComponent";
import GroupIndexComponent from "../groups/GroupIndexComponent";
import ActivityLogIndexComponent from "../activity-log/ActivityLogIndexComponent";
import SettingsIndexComponent from "../settings/SettingsIndexComponent";
import DeviceIndexComponent from "../device/DeviceIndexComponent";
import AccountListIndexComponent from "../account-list/AccountListIndexComponent";
import OrganizationConfirmDeleteComponent from "./Organization/OrganizationConfirmDeleteComponent";
import OrganizationDeleteSuccessComponent from "./Organization/OrganizationDeleteSuccessComponent";
import Component404 from "../Component404";
import {useTranslation} from "react-i18next";
import ReceiveAuthComponent from "../ReceiveAuthComponent";
import {useEffect} from "react";
import JoinOrganizationSuccessComponent from "../JoinOrganizationSuccessComponent";
import SecurityIndexComponent from "../settings/SecurityIndexComponent";
import CloudSpaceIndexComponent from "../cloud-space/CloudSpaceIndexComponent";
import OrganizationPagesLayout from "./OrganizationPagesLayout";

const MainContentIndexComponent = ({setStandalone, refreshOrgList, setShowFooter}) => {
    const {i18n} = useTranslation();
    const [searchParams, setSearchParams] = useSearchParams();

    const initLang = () => {
        const lang = searchParams.get('lang');
        if (lang) {
            let updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.delete('lang');
            setSearchParams(updatedSearchParams.toString());
            i18n.changeLanguage(lang)
        }
    }

    useEffect(()=>{
        initLang();

        if (searchParams.get('from_acc')) {
            let updatedSearchParams = new URLSearchParams(searchParams.toString());
            updatedSearchParams.delete('from_acc');
            setSearchParams(updatedSearchParams.toString());
        }
    }, [])

    return (
        <>
            <MainNavigationComponent />
            <main className="main-content m--main-content">
                <Routes>
                    <Route path="/oauth/receive_auth" element={<ReceiveAuthComponent query={searchParams}/>}></Route>

                    <Route path={"/delete-org-confirm/:deleteToken"} element={<OrganizationConfirmDeleteComponent setStandalone={setStandalone} setShowFooter={setShowFooter}/>}></Route>

                    <Route path={"/delete-organization-success"} element={<OrganizationDeleteSuccessComponent setStandalone={setStandalone} setShowFooter={setShowFooter}/> }></Route>

                    <Route path="/:oid" exact={true} element={<OrganizationPagesLayout />}>
                        <Route path="group" exact={true} element={<GroupIndexComponent />}></Route>
                        <Route path="account-list" exact={true} element={<AccountListIndexComponent />}></Route>
                        <Route path="sites" exact={true} element={<SiteIndexComponent />}></Route>
                        <Route path="devices" exact={true} element={<DeviceIndexComponent />}></Route>
                        <Route path="activity-log" exact={true} element={<ActivityLogIndexComponent />}></Route>
                        <Route path="settings" exact={true} element={<SettingsIndexComponent />}></Route>
                        <Route path="security" exact={true} element={<SecurityIndexComponent />}></Route>
                        <Route path="cloud-space" exact={true} element={<CloudSpaceIndexComponent />}></Route>
                    </Route>

                    <Route path="/join-organization-success/:jid" exact={true} element={<JoinOrganizationSuccessComponent setStandalone={setStandalone} setShowFooter={setShowFooter}/>}></Route>

                    <Route path="/" exact={true} element={<MainContentSummary doRefreshHeaderOrgList={refreshOrgList} />}></Route>

                    <Route path="/404_page_not_found" element={<Component404 setStandalone={setStandalone} setShowFooter={setShowFooter}/>}></Route>

                    <Route path="*" element={<Navigate to="/404_page_not_found"/>}></Route>

                </Routes>
            </main>
        </>
    );
};

export default MainContentIndexComponent;